module.exports = __webpack_public_path__ + "img/pink_squares.6ef5284d.png";